/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Tsb_One_LinerInputs */

const en_exp_tsb_one_liner = /** @type {(inputs: Exp_Tsb_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How fresh or fatigued you are right now — positive means rested, negative means tired. Today's training already counts.`)
};

const de_exp_tsb_one_liner = /** @type {(inputs: Exp_Tsb_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie frisch oder müde du gerade bist — positiv = erholt, negativ = müde. Das heutige Training zählt schon mit.`)
};

/**
* | output |
* | --- |
* | "How fresh or fatigued you are right now — positive means rested, negative means tired. Today's training already counts." |
*
* @param {Exp_Tsb_One_LinerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_tsb_one_liner = /** @type {((inputs?: Exp_Tsb_One_LinerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Tsb_One_LinerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_tsb_one_liner(inputs)
	return de_exp_tsb_one_liner(inputs)
});